import React from 'react';

export const ImageFileCheck = () => (
    <g>
        <path d='M17.5,11c-3.584,0-6.5,2.916-6.5,6.5c0,3.584,2.916,6.5,6.5,6.5s6.5-2.916,6.5-6.5C24,13.916,21.084,11,17.5,11z M17.5,23
			c-3.032,0-5.5-2.467-5.5-5.5s2.468-5.5,5.5-5.5s5.5,2.467,5.5,5.5S20.532,23,17.5,23z' />
        <path d='M20.146,15.146L16.5,18.793l-1.646-1.646c-0.195-0.195-0.512-0.195-0.707,0s-0.195,0.512,0,0.707l2,2
			C16.244,19.951,16.372,20,16.5,20s0.256-0.049,0.354-0.146l4-4c0.195-0.195,0.195-0.512,0-0.707S20.342,14.951,20.146,15.146z' />
        <path d='M7.646,14.854c0.111,0.111,0.271,0.165,0.425,0.142c0.156-0.022,0.292-0.117,0.367-0.256l2.498-4.58l0.463,1.122
			c0.105,0.256,0.397,0.377,0.652,0.272c0.255-0.105,0.377-0.397,0.271-0.653L11.462,8.81c-0.073-0.178-0.242-0.298-0.435-0.309
			c-0.214-0.019-0.374,0.091-0.466,0.26l-2.681,4.913l-1.527-1.527c-0.113-0.114-0.275-0.166-0.434-0.14s-0.295,0.126-0.367,0.27
			l-2.5,5c-0.077,0.155-0.069,0.339,0.021,0.486C3.166,17.911,3.327,18,3.5,18h5.459c0.276,0,0.5-0.224,0.5-0.5S9.235,17,8.959,17
			h-4.65l1.828-3.656L7.646,14.854z' />
        <path d='M5,9c1.103,0,2-0.897,2-2c0-1.103-0.897-2-2-2S3,5.897,3,7C3,8.103,3.897,9,5,9z M5,6c0.552,0,1,0.449,1,1S5.552,8,5,8
			S4,7.551,4,7S4.448,6,5,6z' />
        <path d='M10.5,21H1V1h10v4.5C11,5.776,11.224,6,11.5,6H16v3.5c0,0.276,0.224,0.5,0.5,0.5S17,9.776,17,9.5v-4
			c0-0.067-0.014-0.132-0.039-0.192c-0.025-0.061-0.062-0.116-0.108-0.162l-4.998-4.999c-0.046-0.045-0.101-0.083-0.162-0.107
			C11.632,0.014,11.566,0,11.5,0h-11C0.224,0,0,0.224,0,0.5v21C0,21.776,0.224,22,0.5,22h10c0.276,0,0.5-0.224,0.5-0.5
			S10.776,21,10.5,21z M12,1.707L15.293,5H12V1.707z' />
    </g>
);